'use client'

import styled, {css} from 'styled-components'

import Button from '@/src/shared/ui/button'

export const Offers = styled.div``

export const OfferContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const OfferValues = styled.div`
  display: flex;
  flex-flow: wrap;
  gap: 3px;
  padding-bottom: 10px;
`

export const OfferValue = styled(Button)<{
  $primary?: boolean
  disabled?: boolean
  hidden?: boolean
}>`
  display: ${props => (!props.hidden && 'flex') || 'none'};
  align-items: center;
  justify-content: center;

  border-radius: 5px;
  min-width: 40px;

  padding: 9px 5px;

  font-size: 1rem;
  font-weight: 450;

  ${props =>
    props.disabled &&
    css`
      background: ${props.theme.colors.gray5};

      &:hover {
        cursor: not-allowed;
      }
    `}
`
